export const environment = {
  production: true,
  apiHost: 'http://60.249.13.54:8106/bcm/data',
  allowBackStageDomain: [
    'http://localhost:4300',
    'http://60.249.13.54:8106',
    'http://tacr.goodays.cc:8106',
  ],
  recaptchaKey: '6Lc0oWghAAAAAGVMVHXeCEJv72mL2mXHO0O_9F5Q',
  commonToken: '8CC1C549-35D7-4691-9E1D-67D8EC7951B5',
  memberWeb: 'http://membertest.moc.gov.tw/MOCMC/T0001/list?SYS_ID=NMTH_TCMB&IS_DEV=Y',
  memberLogout: 'http://membertest.moc.gov.tw/MOCMC/M0003/logout?SYS_ID=NMTH_TCMB&IS_DEV=Y',
  itriSearchApiHost: 'http://61.216.92.20:32175',
  itriAutoCompleteApiHost: 'http://61.216.92.20:32173',
  googleSiteVerification: 'zLq_nf1oYfz_GD5l5kzXdyvxgof9MoQa-oWkehJUjNI',
  imagorHost: 'http://192.168.0.3:8000/unsafe',
};
